import React from 'react';
import { SnackbarProvider as NotistackSnackbarProvider, closeSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const CloseButton = () => (
  <IconButton onClick={() => closeSnackbar()}>
    <HighlightOffIcon sx={{ color: '#FFF' }} />
  </IconButton>
);

const SnackbarProvider = ({ children }) => (
  <NotistackSnackbarProvider
    persist
    maxSnack={1}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    iconVariant={{ error: <ErrorOutlineIcon sx={{ mr: '10px' }} /> }}
    action={CloseButton}
    style={{ flexWrap: 'nowrap' }}
  >
    {children}
  </NotistackSnackbarProvider>
);

export default SnackbarProvider;
